import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import AssignTestModal from "./AssignTestModal";
import DrilldownModal from "./DrilldownModal";
import Select from "react-select";
import { GET_WHATSAPP_LEADS, GET_WHATSAPP_LEAD_TIMELINE, GET_WHATSAPP_TAGS } from "../../utils/whatsappHelper";
import "./_admissionForms.scss";

const FETCH_STATE = gql`
query ($id: Int!) {
  getState(id: $id) {
    state_id
    state_name
  }
}
`;

const FETCH_DISTRICT = gql`
query ($state_id: Int!) {
  getDistricts(state_id: $state_id) {
    id
    district_name
  }
}
`;

const FETCH_CITY = gql`
query ($district_id: Int!) {
  getCities(district_id: $district_id) {
    id
    city_name
  }
}
`;

const FETCH_BRANCH = gql`
query ($institution_id: Int!) {
  getBranchNames(institution_id: $institution_id) {
    id
    branch_name
  }
}
`;

const FETCH_SECTION = gql`
query ($institution_id: Int!) {
  getSectionNames(institution_id: $institution_id) {
    id
    section_name
  }
} 
`;

const FETCH_EXAMS = gql`
query($institution_id: Int!){
  getDashBoardExams(institution_id : $institution_id){
    quiz_exams{
      id
      exam_name
      exam_type
    }
    full_exams{
      id
      exam_mode
      exam_name
      exam_type
    }
  }
}
`;


// Reusing same queries to minimize backend changes, but we will aggregate data differently
const GET_ENQUIRY_FORMS = gql`
  query ($institute_id: Int!, $branch_id: Int!) {
    getEnquiryForms(institute_id: $institute_id, branch_id: $branch_id) {
      form_name
      id
      lead_count
      source_details {
        source_name
        source_count
      }
    }
  }
`;

const GET_ENQUIRY_FORM_FIELDS = gql`
  query ($form_id: Int!) {
    getEnquiryFormFields(form_id: $form_id) {
      id
      field_name
      is_mandatory
    }
  }
`;

const GET_ADMISSION_ANALYTICS = gql`
  query ($institute_id: Int!, $branch_id: Int!) {
    getAdmissionAnalytics(institute_id: $institute_id, branch_id: $branch_id) {
      total_enquiries
      tests_assigned
      tests_completed
      total_admitted
    }
  }
`;

// Chart and UI configuration
const COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6"];

class AdmissionsDashboardHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBranches: [],
      branchError: "",
      loader: false,
      dashboardData: null,
      noDataError: "",
      copySuccess: {},
      leadAnalytics: null,
      recentActivity: [],
      crmLeads: [],
      // Cascading Filter State
      stateValue: null,
      districtValue: null,
      cityValue: null,
      branchValue: null,
      sectionValue: null,
      exam_typeValue: null,
      districtOptions: [],
      cityOptions: [],
      branchOptions: [],
      sectionOptions: [],
      examTypeOptions: [],
      // Drilldown Modal State
      showDrilldown: false,
      drilldownType: null,
      drilldownTitle: "",
      drilldownData: [],
      drilldownLoading: false,
      // Timeframe State
      selectedTimeframe: "last_30",

    };
  }

  getAuthorizedIds = () => {
    let authorizedIds = [];
    try {
      const cookie = Cookies.get("branch_id") || Cookies.get("branchid");
      if (cookie) {
        if (cookie.startsWith('[')) {
          authorizedIds = JSON.parse(cookie);
        } else {
          authorizedIds = cookie.split(",").map(id => id.trim());
        }
      }
    } catch (e) {
      console.warn("Error parsing branch_id cookie", e);
    }
    return authorizedIds.map(String);
  };

  getPermittedBranchIds = () => {
    let permittedBranchIds = [];
    try {
      const branchesCookie = Cookies.get("branches");
      const singleId = Cookies.get("branch_id") || Cookies.get("branchid");

      if (branchesCookie) {
        if (branchesCookie.startsWith('[')) {
          permittedBranchIds = JSON.parse(branchesCookie).map(id => parseInt(id));
        } else {
          permittedBranchIds = branchesCookie.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
        }
      } else if (singleId) {
        permittedBranchIds = [parseInt(singleId)];
      }
    } catch (e) {
      console.warn("Error parsing branches cookie", e);
    }
    return permittedBranchIds;
  };

  componentDidMount() {
    const branches = this.props.globals && this.props.globals.globalBranches;
    if (branches && branches.length > 0) {
      const authorizedIds = this.getAuthorizedIds();
      const permittedIds = this.getPermittedBranchIds();

      let selected = branches
        .filter(b => authorizedIds.includes("all") || authorizedIds.includes(String(b.id)))
        .map((b) => ({
          label: b.branch_name,
          value: b.id,
        }));

      if (permittedIds.length > 0) {
        selected = selected.filter(b => permittedIds.includes(parseInt(b.value)));
      }

      // Fallback: if all branches were filtered out (cookie mismatch), use all branches
      if (selected.length === 0) {
        console.warn("Dashboard: all branches filtered out — using all globalBranches as fallback");
        selected = branches.map(b => ({ label: b.branch_name, value: b.id }));
      }

      this.setState({ selectedBranches: selected }, () => {
        this.fetchDashboardData(selected);
      });
    } else {
      // Fallback: globalBranches not available — build from cookie directly
      const branchId = parseInt(Cookies.get("branchid") || Cookies.get("branch_id")) || 0;
      const branchName = Cookies.get("branch_name") || "My Branch";
      if (branchId) {
        const fallback = [{ label: branchName, value: branchId }];
        console.warn("Dashboard: globalBranches empty — using cookie fallback:", fallback);
        this.setState({ selectedBranches: fallback }, () => {
          this.fetchDashboardData(fallback);
        });
      } else {
        this.setState({ noDataError: "No branch information found. Please contact your administrator." });
      }
    }
  }

  handleLocationChange = (name, option) => {
    if (name === "state") {
        this.setState({
            stateValue: option,
            districtOptions: option ? (option.districts || []) : [],
            districtValue: null, cityValue: null, branchValue: null, sectionValue: null,
            cityOptions: [], branchOptions: [], sectionOptions: []
        }, this.triggerGlobalFilter);
        if (option && this.props.getDistricts) this.props.getDistricts.refetch({ state_id: option.value });
    }

    if (name === "district") {
        this.setState({
            districtValue: option,
            cityOptions: option ? (option.cities || []) : [],
            cityValue: null, branchValue: null, sectionValue: null,
            branchOptions: [], sectionOptions: []
        }, this.triggerGlobalFilter);
        if (option && this.props.getCities) this.props.getCities.refetch({ district_id: option.value });
    }

    if (name === "city") {
        this.setState({
            cityValue: option,
            branchOptions: option ? (option.branches || []) : [],
            branchValue: null, sectionValue: null, sectionOptions: []
        }, this.triggerGlobalFilter);
        if (option && this.props.getBranches) this.props.getBranches.refetch({ city_id: option.value }).catch(() => {});
    }

    if (name === "branch") {
        this.setState({
            branchValue: option,
            sectionOptions: option ? (option.sections || []) : [],
            sectionValue: null
        }, this.triggerGlobalFilter);
        if (option && this.props.getSections) this.props.getSections.refetch({ branch_id: option.value }).catch(() => {});
    }

    if (name === "section") {
        this.setState({ sectionValue: option }, this.triggerGlobalFilter);
    }
    
    if (name === "exam_type") {
        this.setState({ exam_typeValue: option }, this.triggerGlobalFilter);
    }
  };

  triggerGlobalFilter = () => {
      let targetBranches = [];
      if (this.state.branchValue) {
          targetBranches = [this.state.branchValue];
      } else if (this.state.cityValue && this.props.getBranches && this.props.getBranches.getBranchNames) {
          targetBranches = this.props.getBranches.getBranchNames.map(b => ({ label: b.branch_name, value: b.id }));
      } else if (this.state.districtValue && this.props.getCities && this.props.getCities.getCities) {
           targetBranches = (this.props.globals.globalBranches || []).map(b => ({ label: b.branch_name, value: b.id }));
      } else {
           targetBranches = (this.props.globals.globalBranches || []).map(b => ({ label: b.branch_name, value: b.id }));
      }

      this.setState({ selectedBranches: targetBranches }, () => {
          this.fetchDashboardData(targetBranches);
      });
  };

  handleBranchChange = (selected) => {
    this.setState({ selectedBranches: selected, branchError: "" }, () => {
      if (selected && selected.length > 0) {
        this.fetchDashboardData(selected);
      } else {
        this.setState({ dashboardData: null, noDataError: "Please select at least one branch to view admission analytics." });
      }
    });
  };

  fetchDashboardData = async (branches) => {
    if (!branches || branches.length === 0) {
      this.setState({ branchError: "Please select at least one branch" });
      return;
    }
    this.setState({ loader: true, dashboardData: null, noDataError: "", branchError: "" });

    const institutionId = parseInt(Cookies.get("institutionid")) || parseInt(Cookies.get("institution_id")) || 0;
    const employeeId = parseInt(Cookies.get("id")) || parseInt(Cookies.get("employee_id")) || 0;
    console.log("Dashboard fetch started with context:", { institutionId, employeeId, branchesCount: branches.length });

    try {
      const [results, leadResult, tagsResult] = await Promise.all([
        Promise.all(branches.map((branch) =>
        this.props.client
          .query({
            query: GET_ENQUIRY_FORMS,
            variables: {
              institute_id: parseInt(Cookies.get("institutionid")),
              branch_id: parseInt(branch.value), // Int! per schema
            },
            fetchPolicy: "network-only",
          })
          .catch(err => {
            console.error("[Dashboard] GET_ENQUIRY_FORMS failed for branch", branch.value, err.message);
            return { data: { getEnquiryForms: [] } };
          })
          .then(async (result) => {
            const rawForms = (result.data && result.data.getEnquiryForms) || [];
            console.log(`[Dashboard] branch ${branch.value} (${branch.label}): ${rawForms.length} forms found`);

            // For each form, fetch its field names for the card display
            const enrichedForms = await Promise.all(
              rawForms.map(async (f) => {
                let fieldNames = [];
                try {
                  const fieldsResult = await this.props.client.query({
                    query: GET_ENQUIRY_FORM_FIELDS,
                    variables: { form_id: f.id },
                    fetchPolicy: "network-only",
                  });
                  fieldNames = (fieldsResult.data.getEnquiryFormFields || []).map(
                    (field) => field.field_name,
                  );
                } catch (e) {
                  console.log("Could not fetch fields for form", f.id);
                }
                return {
                  ...f,
                  fieldNames,
                  form_url: `https://rizee.in/admission-form/${f.id}`
                };
              })
            );

              let pipeline = {
                totalEnquiries: 0,
                testsAssigned: 0,
                testsCompleted: 0,
                admitted: 0,
              };

            try {
              const analyticsResult = await this.props.client.query({
                query: GET_ADMISSION_ANALYTICS,
                variables: {
                  institute_id: parseInt(Cookies.get("institutionid")),
                  branch_id: parseInt(branch.value),
                },
                fetchPolicy: "network-only",
              });
              const analytics = analyticsResult.data.getAdmissionAnalytics;
              console.log(`[Dashboard] analytics for branch ${branch.value}:`, analytics);
              if (analytics) {
                pipeline = {
                  totalEnquiries: analytics.total_enquiries,
                  testsAssigned: analytics.tests_assigned,
                  testsCompleted: analytics.tests_completed,
                  admitted: analytics.total_admitted,
                };
              }
            } catch (e) {
              console.warn("[Dashboard] getAdmissionAnalytics failed for branch", branch.value, e.message);
            }

              let branchTotalLeads = 0;
              let sourceMap = {};

              enrichedForms.forEach((f) => {
                branchTotalLeads += f.lead_count || 0;
                if (f.source_details && f.source_details.length > 0) {
                  f.source_details.forEach((src) => {
                    sourceMap[src.source_name] =
                      (sourceMap[src.source_name] || 0) + src.source_count;
                  });
                }
              });

              return {
                branch_name: branch.label,
                branch_id: branch.value,
                forms_count: enrichedForms.length,
                total_leads: branchTotalLeads,
                pipeline,
                sourceMap,
                forms: enrichedForms,
              };
            })
        )),
        // Fetch CRM leads separately so a CRM failure doesn't kill the education data fetch
        employeeId
          ? this.props.client.query({
              query: GET_WHATSAPP_LEADS,
              variables: { employee_id: employeeId },
              fetchPolicy: "network-only"
            }).catch(e => {
              console.warn("CRM leads fetch failed (non-critical):", e.message);
              return { data: { getWhatsAppLeads: null } };
            })
          : Promise.resolve({ data: { getWhatsAppLeads: null } }),
        employeeId
          ? this.props.client.query({
              query: GET_WHATSAPP_TAGS,
              variables: { employee_id: employeeId },
              fetchPolicy: "network-only"
            }).catch(e => {
              console.warn("CRM tags fetch failed (non-critical):", e.message);
              return { data: { getWhatsAppTags: null } };
            })
          : Promise.resolve({ data: { getWhatsAppTags: null } })
      ]);

      console.log("Education results (getEnquiryForms):", results);
      console.log("CRM leads (getWhatsAppLeads) raw length:", leadResult.data.getWhatsAppLeads?.length);

      // Parse CRM Leads
      let crmLeads = [];
      try {
        const rawLeads = leadResult.data.getWhatsAppLeads;
        if (rawLeads) {
          const parsed = JSON.parse(rawLeads);
          crmLeads = parsed.data || [];
        }
      } catch (e) {
        console.error("Failed to parse Lead Analytics", e);
      }
      console.log("CRM leads parsed count:", crmLeads.length);

      // Parse CRM Tags
      let crmTags = [];
      try {
        const rawTags = tagsResult.data.getWhatsAppTags;
        if (rawTags && rawTags.data) {
           crmTags = typeof rawTags.data === 'string' ? JSON.parse(rawTags.data) : rawTags.data;
        } else if (rawTags && typeof rawTags === 'string') {
           const parsed = JSON.parse(rawTags);
           crmTags = parsed.data || [];
        }
      } catch (e) {
        console.error("Failed to parse CRM Tags", e);
      }

      // Map tags to counts from crmLeads
      let tagCounts = {};
      crmLeads.forEach(l => {
         if (l.tag_id) {
            const tId = String(l.tag_id);
            tagCounts[tId] = (tagCounts[tId] || 0) + 1;
         }
      });

      let richTags = crmTags.map(t => ({
         name: t.tag_name,
         value: tagCounts[String(t.id)] || 0,
         id: t.id
      })).filter(t => t.value > 0).sort((a, b) => b.value - a.value);

      // Frontend Timeframe Filtering for CRM Leads (Enquiries, Staff Notes, etc.)
      const now = new Date();
      if (this.state.selectedTimeframe !== "all") {
        crmLeads = crmLeads.filter(l => {
          if (!l.updated_at) return false;
          const updated = new Date(l.updated_at);
          const diffDays = (now - updated) / (1000 * 60 * 60 * 24);
          
          switch(this.state.selectedTimeframe) {
            case 'today': return diffDays <= 1;
            case 'last_7': return diffDays <= 7;
            case 'last_30': return diffDays <= 30;
            case 'last_60': return diffDays <= 60;
            case 'last_90': return diffDays <= 90;
            default: return true;
          }
        });
      }

      // Populate recent activity from leads that have comments or recent status changes
      const recentActivity = Array.isArray(crmLeads) 
        ? crmLeads
            .filter(l => l.comments || l.updated_at)
            .sort((a, b) => new Date(b.updated_at || 0) - new Date(a.updated_at || 0))
            .slice(0, 5)
        : [];

      console.log("Dashboard Fetch Results:", results);

      // Relaxed filter: Show dashboard if results exist, even if counts are zero
      // A branch has data if it has forms OR if its pipeline has any entries
      const withData = results.filter((r) => r.forms_count > 0 || r.pipeline.totalEnquiries > 0 || r.total_leads > 0);
      
      // If we have selected branches but no data, we should still show the dashboard components with zeros 
      // instead of a global "No Data" screen, provided results came back.
      const shouldShowDashboard = results.length > 0;

      if (shouldShowDashboard) {
        let globalSourceMap = {};
        let grandPipeline = {
          totalEnquiries: 0,
          testsAssigned: 0,
          testsCompleted: 0,
          admitted: 0,
        };

        results.forEach((branch) => {
          // If the specialized analytics query returned 0, fallback to summing form lead_counts
          const branchEnquiries = branch.pipeline.totalEnquiries || branch.total_leads || 0;
          
          grandPipeline.totalEnquiries += branchEnquiries;
          grandPipeline.testsAssigned += branch.pipeline.testsAssigned || 0;
          grandPipeline.testsCompleted += branch.pipeline.testsCompleted || 0;
          grandPipeline.admitted += branch.pipeline.admitted || 0;

          Object.keys(branch.sourceMap).forEach((key) => {
            globalSourceMap[key] =
              (globalSourceMap[key] || 0) + branch.sourceMap[key];
          });
        });

        // Final fallback for Total Enquiries: if still 0, use CRM leads count
        if (grandPipeline.totalEnquiries === 0 && crmLeads.length > 0) {
          console.log("Fallback: Using CRM leads count for total enquiries");
          grandPipeline.totalEnquiries = crmLeads.length;
        }

        // Format chart data
        const sourceChartData = Object.keys(globalSourceMap)
          .map((key) => ({
            name: key,
            value: globalSourceMap[key],
          }))
          .sort((a, b) => b.value - a.value);

        const branchChartData = results.map((b) => ({
          name: b.branch_name,
          Applications: b.total_leads,
          Admitted: b.pipeline.admitted,
        }));

        this.setState({
          dashboardData: {
            branches: results,
            grandTotalLeads: grandPipeline.totalEnquiries,
            grandPipeline,
            sourceChartData,
            branchChartData,
            richTags,
            totalForms: results.reduce(
              (acc, curr) => acc + curr.forms_count,
              0,
            ),
          },
          crmLeads,
          recentActivity,
          loader: false,
        });
      } else {
        this.setState({
          loader: false,
          noDataError: "No admission data found for the selected branches.",
        });
      }
    } catch (err) {
      console.error("[Dashboard] fetchDashboardData OUTER catch:", err?.message, err);
      this.setState({
        loader: false,
        noDataError: `Failed to load dashboard data. Error: ${err?.message || "Unknown error"}`,
      });
    }
  };

  handleCopy = (url, formId) => {
    navigator.clipboard.writeText(url).then(() => {
      this.setState({ copySuccess: { [formId]: true } });
      setTimeout(() => this.setState({ copySuccess: { [formId]: false } }), 2000);
    });
  };

  handleTimeframeChange = (e) => {
    this.setState({ selectedTimeframe: e.target.value }, () => {
      this.fetchDashboardData(this.state.selectedBranches);
    });
  };

  openDrilldownModal = async (type) => {
    let title = "";
    let data = [];
    
    const { crmLeads, dashboardData } = this.state;
    if (!dashboardData) return;

    this.setState({ showDrilldown: true, drilldownLoading: true, drilldownType: type });

    switch(type) {
      case 'enquiries':
        title = "Total Student Enquiries";
        // Map CRM Leads to modal format if they belong to selected branches
        data = crmLeads.map(l => ({
          name: l.name || l.mobile,
          mobile: l.mobile,
          branch_name: l.branch_name || 'General',
          status: l.lead_status || 'Interested',
          statusColor: 'badge-soft-primary'
        }));
        break;
      case 'tests':
        title = "Academic Tests Assigned";
        data = crmLeads.filter(l => l.lead_status === 'Test Assigned').map(l => ({
          name: l.name || l.mobile,
          mobile: l.mobile,
          branch_name: l.branch_name || 'General',
          status: 'Assigned',
          statusColor: 'badge-soft-info'
        }));
        break;
      case 'completed':
        title = "Tests Completed";
        data = crmLeads.filter(l => l.lead_status === 'Test Completed').map(l => ({
          name: l.name || l.mobile,
          mobile: l.mobile,
          branch_name: l.branch_name || 'General',
          status: 'Completed',
          statusColor: 'badge-soft-success'
        }));
        break;
      case 'admitted':
        title = "Final Admitted Students";
        data = crmLeads.filter(l => l.lead_status === 'Admitted').map(l => ({
          name: l.name || l.mobile,
          mobile: l.mobile,
          branch_name: l.branch_name || 'General',
          status: 'Admitted',
          statusColor: 'badge-soft-success'
        }));
        break;
      default:
        title = "Student Details";
    }

    this.setState({ 
      drilldownTitle: title, 
      drilldownData: data,
      drilldownLoading: false 
    });
  };

  resolveFieldNames = (item) => {
    // These 6 fields are standard mandatory fields for all forms
    const standardMandatory = ["Name", "Mobile", "Date of Birth", "Gender", "Course Name", "Email"];

    // item.fieldNames contains ALL field names fetched per-form.
    // We need to split mandatory vs optional, and deduplicate.
    const allNames = item.fieldNames || [];
    const isMandatoryMatch = (name) => {
      const l = (name || "").toLowerCase().trim();
      return (
        l === "name" ||
        l === "student name" ||
        l === "mobile" ||
        l === "mobile number" ||
        l === "student mobile" ||
        l.includes("email") ||
        l.includes("gender") ||
        l === "date of birth" ||
        l === "dob" ||
        l === "course name" ||
        l === "course"
      );
    };

    const seen = new Set();
    const mandatory = [];
    const optional = [];

    // Always include the standard 6 first
    standardMandatory.forEach(m => {
      mandatory.push(m);
      seen.add(m.toLowerCase());
    });

    allNames.forEach((n) => {
      const l = (n || "").toLowerCase().trim();
      if (seen.has(l)) return;
      seen.add(l);

      if (isMandatoryMatch(n)) {
        mandatory.push(n);
      } else {
        optional.push(n);
      }
    });

    return { mandatory, optional };
  };

  render() {
    const { 
        loader, noDataError, dashboardData, selectedTimeframe, crmLeads,
        stateValue, districtValue, cityValue, branchValue, sectionValue, exam_typeValue 
    } = this.state;
    // Branch options — from globalBranches prop, filtered by user's authorized IDs
    const { globals } = this.props;
    const authorizedIds = this.getAuthorizedIds();
    const permittedIds = this.getPermittedBranchIds();

    const allGlobalBranches = (globals && globals.globalBranches) ? globals.globalBranches : [];


    let branchOptions = allGlobalBranches
        .filter(b => authorizedIds.includes("all") || authorizedIds.includes(String(b.id || b.value)))
        .map((b) => ({ label: b.branch_name || b.label, value: b.id || b.value }));

    // Fallback: if filter removes everything, use all global branches
    if (branchOptions.length === 0 && allGlobalBranches.length > 0) {
      branchOptions = allGlobalBranches.map(b => ({ label: b.branch_name || b.label, value: b.id || b.value }));
    }

    if (permittedIds.length > 0) {
      const filtered = branchOptions.filter(b => permittedIds.includes(parseInt(b.value)));
      if (filtered.length > 0) branchOptions = filtered;
    }


    // Calculate rates
    let conversionRate = "0%";
    let completionRate = "0%";
    let assignmentRate = "0%";

    if (dashboardData && dashboardData.grandTotalLeads > 0) {
      assignmentRate = Math.round((dashboardData.grandPipeline.testsAssigned / dashboardData.grandTotalLeads) * 100) + "%";
      conversionRate =
        Math.round(
          (dashboardData.grandPipeline.admitted /
            dashboardData.grandTotalLeads) *
          100,
        ) + "%";
    }

    if (dashboardData && dashboardData.grandPipeline.testsAssigned > 0) {
      completionRate =
        Math.round(
          (dashboardData.grandPipeline.testsCompleted /
            dashboardData.grandPipeline.testsAssigned) *
          100,
        ) + "%";
    }

    return (
      <Container fluid className="af-admission-dashboard py-4 bg-white min-vh-100">
        <style>{`
          /* Aggressive CSS Reset for ANY MultiSelect Library */
          div[class*="rmsc"], div[class*="multi-select"], div[class*="dropdown-content"] {
            --rmsc-bg: #fff !important;
            --rmsc-hover: #f1f5f9 !important;
            --rmsc-border: #e2e8f0 !important;
          }
          
          /* Target Select Container */
          div[class*="dropdown-container"] {
            border-radius: 6px !important;
            border-color: #e2e8f0 !important;
            min-height: 40px !important;
            background: #fff !important;
          }

          /* Target Dropdown Items */
          div[class*="dropdown-content"] {
             background: #fff !important;
             border-radius: 6px !important;
             box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1) !important;
             border: 1px solid #e2e8f0 !important;
             z-index: 9999 !important;
          }

          div[class*="dropdown-content"] *, 
          div[class*="dropdown-content"] label,
          div[class*="dropdown-content"] li,
          div[class*="item-renderer"],
          div[class*="select-item"] {
            background-color: transparent !important;
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
            color: #334155 !important;
          }

          /* Hover State */
          div[class*="dropdown-content"] label:hover,
          div[class*="dropdown-content"] li:hover,
          div[class*="select-item"]:hover {
            background-color: #f1f5f9 !important;
            background: #f1f5f9 !important;
          }

          /* Search bar */
          div[class*="dropdown-content"] input[type="text"] {
             background-color: #f8fafc !important;
             border: 1px solid #e2e8f0 !important;
             border-radius: 4px !important;
             margin: 4px !important;
             padding: 8px !important;
          }

          /* Classic Pro Drilldown Styles */
          .af-kpi-drilldown-card {
            cursor: pointer;
            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
            border: 1px solid #e2e8f0 !important;
            position: relative;
            overflow: hidden;
          }
          .af-kpi-drilldown-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
            border-color: #3b82f6 !important;
          }
          .af-kpi-drilldown-card:hover .af-metric-icon {
            transform: scale(1.1) rotate(-5deg);
            opacity: 0.08 !important;
          }
          .af-metric-icon {
            transition: all 0.3s ease;
          }
          .af-kpi-drilldown-card::after {
            content: 'View Details →';
            position: absolute;
            bottom: 12px;
            right: 16px;
            font-size: 11px;
            font-weight: 600;
            color: #3b82f6;
            opacity: 0;
            transform: translateX(-10px);
            transition: all 0.2s ease;
          }
          .af-kpi-drilldown-card:hover::after {
            opacity: 1;
            transform: translateX(0);
          }
          .af-kpi-drilldown-card.premium-dark:hover::after {
            color: #fff;
          }
        `}</style>

        {/* ── Breadcrumb Navigation ── */}
        <ul className="af-breadcrumb mt-4">
          <li className="af-bc-item">
            <a href="#/admissions-dashboard" onClick={(e) => { e.preventDefault(); this.props.history.push("/admissions-dashboard"); }}>
              Admissions
            </a>
          </li>
          <li className="af-bc-item active">Dashboard</li>
        </ul>

        {/* ── Dashboard Header & Global Filters ─────────────────────────────── */}
        <div className="af-admin-header mt-4 mb-4">
            <div className="d-flex flex-column flex-xl-row justify-content-between align-items-start align-items-xl-center mb-3" style={{ gap: "16px" }}>
              <div>
                <h4 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
                  Admission Analytics Overview
                </h4>
                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                  Track branch-wise admission status, pipelines, and lead sources in real-time.
                </p>
              </div>

              <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                  <button
                    className="af-cancel-btn d-flex align-items-center"
                    onClick={() => this.props.history.push("/admission-forms")}
                    style={{ height: "38px", gap: "8px" }}
                  >
                    <i className="fas fa-folder-open"></i> Manage Forms
                  </button>
                  <button
                    className="af-save-btn d-flex align-items-center"
                    onClick={() => this.props.history.push("/admission-forms/create")}
                    style={{ height: "38px", gap: "8px" }}
                  >
                    <i className="fas fa-plus"></i> Create New Form
                  </button>
              </div>
            </div>

            {/* Global Reactive Filters — Branch is live; others are placeholders (coming soon) */}
            <div className="af-shadcn-card p-3 d-flex flex-wrap align-items-end" style={{ gap: '12px', zIndex: 90 }}>
                {/* Branch — LIVE */}
                <div style={{ flex: '0 0 220px', minWidth: '180px' }}>
                    <span className="text-muted font-weight-bold d-block mb-1" style={{fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase'}}>Branch</span>
                    <Select
                      value={branchValue}
                      options={branchOptions}
                      onChange={(opt) => this.handleLocationChange("branch", opt)}
                      placeholder="All Branches..."
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>

                {/* Dummy filters — disabled, coming soon */}
                {["State", "District", "City", "Section", "Exam Type"].map(label => (
                  <div key={label} style={{ flex: '0 0 150px', minWidth: '120px', opacity: 0.5 }}>
                    <span className="text-muted font-weight-bold d-block mb-1" style={{fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase'}}>
                      {label} <span style={{fontSize: '9px', background: '#f1f5f9', borderRadius: '4px', padding: '1px 5px', color: '#94a3b8', verticalAlign: 'middle'}}>soon</span>
                    </span>
                    <Select
                      value={null}
                      options={[]}
                      placeholder={`All ${label}s...`}
                      isDisabled
                      menuPortalTarget={document.body}
                    />
                  </div>
                ))}

                {/* Date Range — live */}
                <div style={{ flex: '0 0 160px', minWidth: '130px' }}>
                    <span className="text-muted font-weight-bold d-block mb-1" style={{fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase'}}>Date Range</span>
                    <select 
                       className="form-control" 
                       style={{ height: "38px", fontSize: "14px", color: "#334155", borderColor: "#cbd5e1", borderRadius: "4px" }}
                       value={selectedTimeframe}
                       onChange={this.handleTimeframeChange}
                     >
                       <option value="today">Today</option>
                       <option value="last_7">Last 7 Days</option>
                       <option value="last_30">Last 30 Days</option>
                       <option value="last_60">Last 60 Days</option>
                       <option value="last_90">Last 90 Days</option>
                       <option value="all">All Time</option>
                     </select>
                </div>
            </div>
        </div>

        {/* ── Loading / Error States ─────────────────────────────────────── */}
        {loader && (
          <div className="af-dashboard-skeleton mt-4">
            {/* KPI Skeletons */}
            <Row className="mb-4">
              {[1, 2, 3, 4].map((i) => (
                <Col md={3} key={`kpi-${i}`}>
                   <div className="af-shadcn-card p-4 h-100 pb-5">
                      <span className="af-skeleton-box w-50 mb-3" style={{ height: "12px", display: "block" }}></span>
                      <span className="af-skeleton-box w-25 mb-4" style={{ height: "40px", display: "block" }}></span>
                      <span className="af-skeleton-box w-75 mt-auto" style={{ height: "14px", display: "block" }}></span>
                   </div>
                </Col>
              ))}
            </Row>
            {/* Charts Skeletons */}
            <Row>
              <Col md={8}>
                <div className="af-shadcn-card p-4 h-100" style={{ minHeight: "400px" }}>
                  <span className="af-skeleton-box w-25 mb-5" style={{ height: "18px", display: "block" }}></span>
                  {/* Fake Grid lines */}
                  <div className="w-100 border-bottom mb-4 opacity-25"></div>
                  <div className="w-100 border-bottom mb-4 opacity-25"></div>
                  <div className="w-100 border-bottom mb-4 opacity-25"></div>
                  <div className="w-100 border-bottom mb-4 opacity-25"></div>
                  
                  {/* Fake bars */}
                  <div className="d-flex align-items-end justify-content-around mt-4" style={{ height: "200px" }}>
                    <span className="af-skeleton-box" style={{ width: "40px", height: "150px" }}></span>
                    <span className="af-skeleton-box" style={{ width: "40px", height: "80px" }}></span>
                    <span className="af-skeleton-box" style={{ width: "40px", height: "190px" }}></span>
                    <span className="af-skeleton-box" style={{ width: "40px", height: "120px" }}></span>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="af-shadcn-card p-4 h-100" style={{ minHeight: "400px" }}>
                  <span className="af-skeleton-box w-50 mb-5" style={{ height: "18px", display: "block" }}></span>
                  <div className="d-flex justify-content-center align-items-center h-100 mt-4 pt-4">
                     <span className="af-skeleton-box rounded-circle mx-auto" style={{ width: "220px", height: "220px", display: "block" }}></span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}

        {!loader && noDataError && (
          <div className="text-center py-5 my-5 bg-white rounded shadow-sm border">
            <i className="fas fa-search fa-3x text-muted mb-3" />
            <h5 className="text-dark">No Data Available</h5>
            <p className="text-muted">{noDataError}</p>
          </div>
        )}

        {/* ── Main Dashboard Content ─────────────────────────────────────── */}
        {!loader && dashboardData && (
          <>
            {/* Global Pipeline Header */}
            <div className="d-flex justify-content-between align-items-end mb-3 mt-2">
               <div>
                  <h6 className="font-weight-bold m-0" style={{ color: "#334155" }}>
                      <i className="fas fa-chart-line mr-2 text-primary" />
                      Global Admission Pipeline
                  </h6>
                  <p className="text-muted small m-0 mt-1">
                      Aggregated metrics for selected branches directly from the education database.
                  </p>
               </div>
            </div>

            {/* 1. Top Level KPIs */}
            <Row className="mb-4">
              <Col md={3}>
                <div 
                  className="af-shadcn-card p-4 h-100 position-relative overflow-hidden mb-0 af-kpi-drilldown-card"
                  onClick={() => this.openDrilldownModal('enquiries')}
                >
                  <div
                    className="position-absolute af-metric-icon"
                    style={{ right: "-20px", top: "-20px", opacity: 0.05 }}
                  >
                    <i className="fas fa-users" style={{ fontSize: "120px" }} />
                  </div>
                  <p
                    className="text-uppercase text-muted font-weight-bold mb-1"
                    style={{ fontSize: "12px", letterSpacing: "1px" }}
                  >
                    Total Enquiries
                  </p>
                  <h2
                    className="font-weight-bold mb-0"
                    style={{
                      color: "#0f172a",
                      fontSize: "36px",
                      letterSpacing: "-1px",
                    }}
                  >
                    {dashboardData.grandTotalLeads}
                  </h2>
                  <div
                    className="mt-2 text-success font-weight-bold"
                    style={{ fontSize: "13px" }}
                  >
                    <i className="fas fa-arrow-up mr-1" /> Across{" "}
                    {dashboardData.branches.length} Branches
                  </div>
                </div>
              </Col>
              <Col md={3}>
                <div 
                  className="af-shadcn-card p-4 h-100 position-relative overflow-hidden mb-0 af-kpi-drilldown-card"
                  onClick={() => this.openDrilldownModal('tests')}
                >
                  <div
                    className="position-absolute af-metric-icon"
                    style={{ right: "-20px", top: "-20px", opacity: 0.05 }}
                  >
                    <i
                      className="fas fa-file-signature"
                      style={{ fontSize: "120px" }}
                    />
                  </div>
                  <p
                    className="text-uppercase text-muted font-weight-bold mb-1"
                    style={{ fontSize: "12px", letterSpacing: "1px" }}
                  >
                    Tests Assigned
                  </p>
                  <h2
                    className="font-weight-bold mb-0"
                    style={{
                      color: "#3b82f6",
                      fontSize: "36px",
                      letterSpacing: "-1px",
                    }}
                  >
                    {dashboardData.grandPipeline.testsAssigned}
                  </h2>
                  <div
                    className="mt-2 text-muted font-weight-bold"
                    style={{ fontSize: "13px" }}
                  >
                    {assignmentRate} Assignment Rate
                  </div>
                </div>
              </Col>
              <Col md={3}>
                <div 
                  className="af-shadcn-card p-4 h-100 position-relative overflow-hidden mb-0 af-kpi-drilldown-card"
                  onClick={() => this.openDrilldownModal('completed')}
                >
                  <div
                    className="position-absolute af-metric-icon"
                    style={{ right: "-20px", top: "-20px", opacity: 0.05 }}
                  >
                    <i
                      className="fas fa-check-circle"
                      style={{ fontSize: "120px" }}
                    />
                  </div>
                  <p
                    className="text-uppercase text-muted font-weight-bold mb-1"
                    style={{ fontSize: "12px", letterSpacing: "1px" }}
                  >
                    Tests Completed
                  </p>
                  <h2
                    className="font-weight-bold mb-0"
                    style={{
                      color: "#10b981",
                      fontSize: "36px",
                      letterSpacing: "-1px",
                    }}
                  >
                    {dashboardData.grandPipeline.testsCompleted}
                  </h2>
                  <div
                    className="mt-2 text-muted font-weight-bold"
                    style={{ fontSize: "13px" }}
                  >
                    {completionRate} Completion Rate
                  </div>
                </div>
              </Col>
              <Col md={3}>
                <div
                  className="af-shadcn-card p-4 h-100 position-relative overflow-hidden mb-0 border-0 af-kpi-drilldown-card premium-dark"
                  onClick={() => this.openDrilldownModal('admitted')}
                  style={{
                    cursor: 'pointer',
                    background:
                      "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
                  }}
                >
                  <div
                    className="position-absolute af-metric-icon"
                    style={{ right: "-20px", top: "-20px", opacity: 0.1 }}
                  >
                    <i
                      className="fas fa-graduation-cap"
                      style={{ fontSize: "120px" }}
                    />
                  </div>
                  <p
                    className="text-uppercase font-weight-bold mb-1"
                    style={{
                      fontSize: "12px",
                      letterSpacing: "1px",
                      color: "rgba(255,255,255,0.8)",
                    }}
                  >
                    Final Admitted
                  </p>
                  <h2
                    className="font-weight-bold mb-0 text-white"
                    style={{ fontSize: "36px", letterSpacing: "-1px" }}
                  >
                    {dashboardData.grandPipeline.admitted}
                  </h2>
                  <div
                    className="mt-2 font-weight-bold"
                    style={{ fontSize: "14px", color: "#bfdbfe" }}
                  >
                    {conversionRate} Overall Conversion
                  </div>
                </div>
              </Col>
            </Row>

            {/* My Personal CRM Workspace Header */}
            <div className="d-flex justify-content-between align-items-end mb-3 mt-4">
               <div>
                  <h6 className="font-weight-bold m-0" style={{ color: "#334155" }}>
                      <i className="fas fa-user-circle mr-2 text-success" />
                      My Personal CRM Tasks
                  </h6>
                  <p className="text-muted small m-0 mt-1">
                      Students specifically mapped to you for follow-up in the Communications Center.
                  </p>
               </div>
            </div>

            {/* 1.5 CRM Insight Mini-Row */}
            <Row className="mb-4">
              <Col md={6}>
                 <div className="af-shadcn-card p-3 mb-0 d-flex align-items-center bg-light border-dashed">
                    <div className="rounded-circle bg-white shadow-sm mr-3 d-flex align-items-center justify-content-center" style={{width: '42px', height: '42px'}}>
                        <i className="fas fa-calendar-check text-primary" />
                    </div>
                    <div className="flex-fill">
                        <p className="small text-muted mb-0 font-weight-bold uppercase letter-spacing-1" style={{fontSize: '10px'}}>PENDING FOLLOW-UPS</p>
                        <h4 className="mb-0 font-weight-bold" style={{color: '#0f172a'}}>
                            {this.state.crmLeads.filter(l => l.followup_time && new Date(l.followup_time) <= new Date()).length}
                            <span className="small text-muted ml-2 font-weight-normal" style={{fontSize: '13px'}}>due now</span>
                        </h4>
                    </div>
                    <button 
                        className="btn btn-sm btn-link ml-auto text-primary font-weight-bold text-decoration-none shadow-none"
                        onClick={() => this.props.history.push("/communications-center")}
                        style={{fontSize: '12px'}}
                    >
                        Review List →
                    </button>
                 </div>
              </Col>
              <Col md={6}>
                 <div className="af-shadcn-card p-3 mb-0 d-flex align-items-center" style={{borderLeft: '4px solid #3b82f6'}}>
                    <div className="rounded-circle mr-3 d-flex align-items-center justify-content-center" style={{width: '42px', height: '42px', backgroundColor: '#eff6ff'}}>
                        <i className="fas fa-bolt" style={{color: '#3b82f6'}} />
                    </div>
                    <div className="flex-fill">
                        <p className="small text-muted mb-0 font-weight-bold text-uppercase" style={{fontSize: '10px', letterSpacing: '1px'}}>MY ACTIVE STUDENTS</p>
                        <h4 className="mb-0 font-weight-bold" style={{color: '#0f172a'}}>
                            {this.state.crmLeads.length}
                            <span className="small text-success ml-2 font-weight-normal" style={{fontSize: '11px'}}>
                                <i className="fas fa-user-check mr-1" />
                                Assigned to me
                            </span>
                        </h4>
                    </div>
                    <div className="ml-auto text-right">
                       <p className="x-small text-muted mb-0" style={{fontSize: '10px'}}>Last Sync</p>
                       <p className="x-small font-weight-bold mb-0" style={{fontSize: '11px'}}>Just Now</p>
                    </div>
                 </div>
              </Col>
            </Row>

            {/* 2. Charts Row */}
            <Row className="mb-4">
              {/* Branch Performance Bar Chart */}
              <Col md={8}>
                <div className="af-shadcn-card p-4 h-100 mb-0">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h6
                      className="font-weight-bold m-0"
                      style={{ color: "#334155" }}
                    >
                      Branch-wise Pipeline Conversion
                    </h6>
                    <span className="badge badge-light border text-muted px-3 py-2">
                      Applications vs Admissions
                    </span>
                  </div>
                  <div style={{ height: "300px", width: "100%" }}>
                    <ResponsiveContainer>
                      <BarChart
                        data={dashboardData.branchChartData}
                        margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
                      >
                        <CartesianGrid
                          strokeDasharray="3 3"
                          vertical={false}
                          stroke="#e2e8f0"
                        />
                        <XAxis
                          dataKey="name"
                          axisLine={false}
                          tickLine={false}
                          tick={{ fill: "#64748b", fontSize: 13 }}
                          dy={10}
                        />
                        <YAxis
                          axisLine={false}
                          tickLine={false}
                          tick={{ fill: "#64748b", fontSize: 13 }}
                        />
                        <Tooltip
                          cursor={{ fill: "#f8fafc" }}
                          contentStyle={{
                            borderRadius: "8px",
                            border: "none",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                          }}
                        />
                        <Legend wrapperStyle={{ paddingTop: "20px" }} />
                        <Bar
                          dataKey="Applications"
                          fill="#94a3b8"
                          radius={[4, 4, 0, 0]}
                          maxBarSize={50}
                        />
                        <Bar
                          dataKey="Admitted"
                          fill="#3b82f6"
                          radius={[4, 4, 0, 0]}
                          maxBarSize={50}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Col>

              {/* Student Segments (Tags) Panel */}
              <Col md={4} className="mb-4">
                <div className="af-shadcn-card p-4 h-100 mb-0 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h6 className="font-weight-bold m-0" style={{ color: "#334155" }}>
                      <i className="fas fa-tags mr-2 text-primary"></i> Student Segments
                    </h6>
                    <button 
                      className="btn btn-sm btn-light border py-1"
                      onClick={() => this.props.history.push("/communications-center")}
                      style={{ fontSize: "11px", borderRadius: "12px" }}
                    >
                      View All
                    </button>
                  </div>
                  
                  <div className="flex-grow-1 overflow-auto" style={{ maxHeight: "250px", paddingRight: "4px" }}>
                    {dashboardData.richTags && dashboardData.richTags.length > 0 ? (
                      <div className="d-flex flex-column" style={{ gap: "12px" }}>
                        {dashboardData.richTags.slice(0, 6).map((tag, idx) => {
                          const total = crmLeads.length || 1;
                          const percent = Math.round((tag.value / total) * 100);
                          return (
                            <div key={idx}>
                              <div className="d-flex justify-content-between align-items-end mb-1">
                                <span style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>
                                  {tag.name}
                                </span>
                                <span style={{ fontSize: "12px", color: "#64748b" }}>
                                  <strong>{tag.value}</strong> students
                                </span>
                              </div>
                              <div className="progress" style={{ height: "6px", backgroundColor: "#f1f5f9", borderRadius: "3px" }}>
                                <div 
                                  className="progress-bar rounded-pill" 
                                  role="progressbar" 
                                  style={{ width: `${Math.max(2, percent)}%`, backgroundColor: COLORS[idx % COLORS.length] }}
                                ></div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted text-center p-3">
                        <div style={{ padding: "12px", backgroundColor: "#f8fafc", borderRadius: "50%", marginBottom: "12px" }}>
                          <i className="fas fa-tag" style={{ fontSize: "20px", color: "#cbd5e1" }}></i>
                        </div>
                        <span style={{ fontSize: "14px", fontWeight: "500", color: "#64748b" }}>No Tagged Students</span>
                        <p style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px", marginBottom: "0" }}>
                          Assign tags in the Communications Center to see segments here.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>



            {/* 3. Recent CRM Activity Feed */}
            <Row className="mb-4">
              <Col md={12}>
                <div className="af-shadcn-card overflow-hidden">
                  <div className="af-shadcn-card-header d-flex justify-content-between align-items-center">
                    <h6 className="font-weight-bold m-0" style={{ color: "#0f172a" }}>
                      <i className="fas fa-bolt text-warning mr-2" /> Recent Student Activity
                    </h6>
                    <button 
                      className="btn btn-sm btn-light border"
                      onClick={() => this.props.history.push("/communications-center")}
                    >
                      View Inbox →
                    </button>
                  </div>
                  <div className="card-body p-0">
                    {this.state.recentActivity && this.state.recentActivity.length > 0 ? (
                      <div className="list-group list-group-flush">
                        {this.state.recentActivity.map((activity, idx) => (
                          <div key={idx} className="list-group-item list-group-item-action border-0 px-4 py-3 d-flex align-items-center">
                            <div 
                              className="rounded-circle mr-3 d-flex align-items-center justify-content-center"
                              style={{ 
                                width: "40px", 
                                height: "40px", 
                                backgroundColor: idx % 2 === 0 ? "#eff6ff" : "#f0fdf4",
                                color: idx % 2 === 0 ? "#3b82f6" : "#22c55e"
                              }}
                            >
                              <i className={idx % 2 === 0 ? "fas fa-comment-alt" : "fas fa-phone-alt"} />
                            </div>
                            <div className="flex-fill">
                              <div className="d-flex justify-content-between mb-1">
                                <span className="font-weight-bold text-dark">{activity.name || activity.mobile}</span>
                                <span className="small text-muted">{new Date(activity.updated_at).toLocaleString()}</span>
                              </div>
                              <p className="small text-muted mb-0 text-truncate" style={{ maxWidth: "600px" }}>
                                {activity.comments || "No recent comments recorded for this student."}
                              </p>
                            </div>
                            <div className="ml-3 text-right">
                              <span 
                                className="badge badge-pill px-3 py-1"
                                style={{ 
                                  backgroundColor: "#f1f5f9", 
                                  color: "#475569",
                                  fontSize: "11px"
                                }}
                              >
                                {activity.lead_status || 'Prospective'}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-5 text-muted italic">
                        <i className="fas fa-info-circle mr-2" /> No recent student activity synced.
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>

            {/* 4. Detailed Branch Data Table */}
            <div className="af-shadcn-card overflow-hidden">
              <div className="af-shadcn-card-header d-flex justify-content-between align-items-center">
                <h6
                  className="font-weight-bold m-0"
                  style={{ color: "#0f172a" }}
                >
                  Detailed Branch Breakdown
                </h6>
                <button
                  className="af-cancel-btn btn-sm d-inline-flex align-items-center"
                  onClick={() => window.print()}
                  style={{ gap: "6px" }}
                >
                  <i className="fas fa-print" /> Export Report
                </button>
              </div>
              <div className="table-responsive">
                <table
                  className="table table-hover mb-0"
                  style={{ fontSize: "14px" }}
                >
                  <thead
                    style={{ backgroundColor: "#f8fafc", color: "#64748b" }}
                  >
                    <tr>
                      <th className="border-0 px-4 py-3">Branch Name</th>
                      <th className="border-0 py-3 text-center">
                        Active Forms
                      </th>
                      <th className="border-0 py-3 text-center">
                        Total Enquiries
                      </th>
                      <th className="border-0 py-3 text-center">
                        Tests Assigned
                      </th>
                      <th className="border-0 py-3 text-center">
                        Tests Completed
                      </th>
                      <th className="border-0 py-3 text-center">Admitted</th>
                      <th className="border-0 py-3 text-right px-4">
                        Conv. Rate
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.branches.map((branch, i) => {
                      const rate =
                        branch.total_leads > 0
                          ? Math.round(
                            (branch.pipeline.admitted / branch.total_leads) *
                            100,
                          )
                          : 0;

                      return (
                        <tr 
                          key={branch.branch_id}
                          className="af-table-drilldown-row"
                          onClick={() => this.props.history.push("/admission-forms")}
                          style={{ cursor: "pointer" }}
                        >
                          <td
                            className="px-4 py-3 align-middle font-weight-bold"
                            style={{ color: "#334155" }}
                          >
                            <div className="d-flex align-items-center">
                              <div 
                                className="af-branch-icon-circle mr-3"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "50%",
                                  backgroundColor: "#f1f5f9",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#3b82f6"
                                }}
                              >
                                <i className="fas fa-building" />
                              </div>
                              {branch.branch_name}
                            </div>
                          </td>
                          <td className="py-3 align-middle text-center">
                            <span className="badge badge-pill badge-light border px-2 py-1">
                              {branch.forms_count}
                            </span>
                          </td>
                          <td className="py-3 align-middle text-center font-weight-bold">
                            {branch.total_leads}
                          </td>
                          <td className="py-3 align-middle text-center text-muted">
                            {branch.pipeline.testsAssigned}
                          </td>
                          <td className="py-3 align-middle text-center text-muted">
                            {branch.pipeline.testsCompleted}
                          </td>
                          <td className="py-3 align-middle text-center text-success font-weight-bold">
                            {branch.pipeline.admitted}
                          </td>
                          <td className="py-3 align-middle text-right px-4">
                            <span
                              className={`badge ${rate > 20 ? "badge-soft-success" : "badge-soft-warning"}`}
                              style={{
                                padding: "6px 10px",
                                borderRadius: "20px",
                                fontSize: "12px",
                                backgroundColor:
                                  rate > 20 ? "#dcfce7" : "#fef3c7",
                                color: rate > 20 ? "#166534" : "#92400e",
                              }}
                            >
                              {rate}%
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <style type="text/css">{`
                .badge-soft-success { background-color: #dcfce7; color: #166534; }
                .badge-soft-warning { background-color: #fef3c7; color: #92400e; }
                .af-dash-multiselect .rmsc { --rmsc-main: #3b82f6; --rmsc-hover: #f1f5f9; --rmsc-selected: #e2e8f0; --rmsc-border: #cbd5e1; --rmsc-gray: #64748b; --rmsc-bg: #fff; }
                .af-dash-multiselect .dropdown-container { border: 1px solid #cbd5e1; border-radius: 6px; }
                
                .af-table-drilldown-row {
                  transition: background-color 0.2s ease;
                }
                .af-table-drilldown-row:hover {
                  background-color: #f8fafc !important;
                }
                .af-table-drilldown-row:hover .af-branch-icon-circle {
                  background-color: #3b82f6 !important;
                  color: #fff !important;
                  transform: scale(1.1);
                  transition: all 0.2s ease;
                }

                .list-group-item-action:hover {
                  background-color: #f8fafc !important;
                }

                 @media print {
                    .header-area, #sidebar, .af-filter-bar, .btn { display: none !important; }
                    .main-wrapper { margin-left: 0 !important; }
                    .content-wrapper { padding: 0 !important; }
                 }
            `}</style>

            <DrilldownModal
              show={this.state.showDrilldown}
              onHide={() => this.setState({ showDrilldown: false })}
              title={this.state.drilldownTitle}
              data={this.state.drilldownData}
              loading={this.state.drilldownLoading}
            />
          </>
        )}
      </Container>
    );
  }
}

// Note: FETCH_STATE, FETCH_DISTRICT, FETCH_CITY, FETCH_BRANCH, FETCH_SECTION removed —
// these location cascade queries don't exist in this backend schema.
// Branch filtering is handled via cookies in componentDidMount.
export default compose(
  withRouter,
  withApollo,
  graphql(FETCH_EXAMS, {
    options: () => ({ variables: { institution_id: parseInt(Cookies.get("institutionid")) || 0 } }),
    name: "getDashBoardExams",
  })
)(AdmissionsDashboardHome);
